import { navigate } from './navigate';
import { support } from './support';

export const staticTools = {
  navigate,
  support,
};

